import React, { useState } from 'react';
import { DeleteModal } from '../../pages';
import { observer } from 'mobx-react';
import { InventoryController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { inventoryStore } from '../../stores';



const DeleteModalContainer = ({ closeModal }) => {
    const [loading, setLoading] = useState(false);

    const onDelete = async id => {
        setLoading(true);
        const { selectedStock } = inventoryStore;
        const {
            status,
            errorMessage,
        } = await InventoryController.deleteStock(selectedStock._id);

        if (status === constant.Success) {
            setLoading(false);
            MimaToastUtil.success({
                message: constant.Success,
            });
            return closeModal();
        }
        setLoading(false);
        return MimaToastUtil.error({
            message: errorMessage,
        });
    };


    return (
        <DeleteModal
            closeModal={closeModal}
            type="Stock"
            onDelete={onDelete}
            loading={loading}
        />
    )
}

export default observer(DeleteModalContainer);